import i18n from '../../../../../i18n/i18n';
import {RelativeFilterResponseBody} from '../../../../../types/api/api';

/**
 * The system preset ("Exact Match") is created by the backend with a hardcoded
 * English name, so its name is translated on display. User-created presets show
 * their stored name as-is.
 */
export function getPresetDisplayName(preset: RelativeFilterResponseBody): string {
  return preset.system ? i18n.t('entity.filterForm.savedFilters.exactMatch') : preset.name;
}
